import { scrollMonitorServiceModule } from '../../services/scroll-monitor-service/scroll-monitor-service';
import scrollOverflowIndicatorTemplate from './scroll-overflow-indicator.tpl.html';
import './scroll-overflow-indicator.less';

// how far we must be from the edge before we show or hide the indicator
const SCROLL_INDICATOR_BUFFER = 20;

export const scrollOverflowIndicatorModule = angular
  .module('Q.components.scroll-overflow-indicator', [
    scrollMonitorServiceModule,
  ])

  .directive('scrollOverflowIndicator', function (scrollMonitorService) {
    return {
      restrict: 'E',
      transclude: true,
      template: scrollOverflowIndicatorTemplate,
      link(scope, el, attrs) {
        if (attrs.scrollOverflowIndicator === 'false') return;

        el.addClass('scroll-overflow-indicator');
        el.toggleClass('allow-dark-mode', attrs.allowDarkMode !== undefined);

        const scrollableContainer = el.children()[0];
        const scrollUpIndicator = el.children()[1];
        const scrollDownIndicator = el.children()[2];

        const watcher = scrollMonitorService.addListener(
          scrollableContainer,
          (event, scrollData) => {
            // show we can scroll up only if we've scroll some amount
            el.toggleClass(
              'can-scroll-up',
              scrollData.viewportScrollTop > SCROLL_INDICATOR_BUFFER,
            );

            // space remaining to scroll
            const scrollBottom =
              scrollableContainer.scrollHeight -
              (scrollData.viewportHeight + scrollData.viewportScrollTop);

            el.toggleClass(
              'can-scroll-down',
              scrollBottom > SCROLL_INDICATOR_BUFFER,
            );
          },
        );

        scope.$on('$destroy', () => {
          watcher.destroy();
        });

        [scrollUpIndicator, scrollDownIndicator].forEach((ind) => {
          // pass through the scroll wheel
          angular.element(ind).on('wheel', (event) => {
            if (event.deltaY) {
              el.children('div')[0].scrollTop += event.deltaY;
            }
          });
        });
      },
    };
  });
